/**
 * Cancellation reasons (multilingual), ported verbatim from cpanel
 * `model/helpers.tsx`. The dialog shows the label for the active UI language and
 * sends the canonical Russian string as the reason (cpanel sent the RU value).
 */
export interface CancelReason {
  en: string;
  ru: string;
  uz: string;
}

export const CANCEL_REASONS: readonly CancelReason[] = [
  {
    en: 'Delivery no longer needed',
    ru: 'Доставка больше не нужна',
    uz: 'Yetkazib berish kerak emas',
  },
  {
    en: 'Courier asked to cancel order',
    ru: 'Курьер попросил отменить заказ',
    uz: "Kuryer buyurtmani bekor qilishni so'radi",
  },
  {
    en: 'Unable to reach courier',
    ru: 'Не удалось связаться с курьером',
    uz: "Kuryerga bog'lanib bo'lmadi",
  },
  { en: 'Wait too long', ru: 'Ждать слишком долго', uz: 'Juda uzoq kutish' },
  { en: 'Courier was impolite', ru: 'Курьер был невежлив', uz: 'Kuryer muomilasi yomon' },
  {
    en: 'Courier was not moving in my direction',
    ru: 'Курьер не двигался в моем направлении',
    uz: 'Kuryer men tomon harakat qilmadi',
  },
  {
    en: 'Courier said he had low battery',
    ru: 'Курьер сказал, что у него разрядился аккумулятор',
    uz: 'Kuryer batarekam kam deb aytdi',
  },
];

/** Pick the label for a UI language, falling back to Russian. */
export function cancelReasonLabel(reason: CancelReason, lang: string): string {
  if (lang === 'en') return reason.en;
  if (lang === 'uz') return reason.uz;
  return reason.ru;
}
